module.exports = __webpack_public_path__ + "static/img/food-1.e00d4ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/describe/food-1.png
// module id = 7+1d
// module chunks = 1